var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: "退菜",
        visible: _vm.visible,
        maskClosable: false,
        width: "480px",
        "confirm-loading": _vm.loading,
        "ok-text": "确认退菜",
        "ok-type": "danger",
      },
      on: {
        ok: _vm.onOk,
        cancel: function ($event) {
          return _vm.$emit("cancel")
        },
      },
    },
    [
      _c("div", { staticClass: "ri-tip" }, [
        _vm._v("\n    退菜需填写理由（必填），确认后该菜品金额不再计入账单，"),
        _c("br"),
        _vm._v("并将打印退菜单通知厨房与传菜部。\n  "),
      ]),
      _vm.itemName
        ? _c("div", { staticClass: "ri-item" }, [
            _c("span", { staticClass: "ri-item-label" }, [_vm._v("退菜菜品")]),
            _c("span", { staticClass: "ri-item-name" }, [
              _vm._v(_vm._s(_vm.itemName)),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "ri-field" },
        [
          _c("span", { staticClass: "ri-label" }, [
            _c("i", { staticClass: "req" }, [_vm._v("*")]),
            _vm._v("退菜理由"),
          ]),
          _c(
            "a-select",
            {
              staticStyle: { width: "100%" },
              attrs: {
                placeholder: "请选择常用退菜理由",
                getPopupContainer: (trigger) => trigger.parentElement,
                allowClear: "",
              },
              model: {
                value: _vm.reason,
                callback: function ($$v) {
                  _vm.reason = $$v
                },
                expression: "reason",
              },
            },
            _vm._l(_vm.reasons, function (r) {
              return _c("a-select-option", { key: r, attrs: { value: r } }, [
                _vm._v(_vm._s(r)),
              ])
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "ri-field" },
        [
          _c("span", { staticClass: "ri-label" }, [_vm._v("自定义理由")]),
          _c("a-input", {
            attrs: {
              placeholder: "或直接输入自定义理由（优先于下拉选择）",
              maxLength: 100,
            },
            model: {
              value: _vm.customReason,
              callback: function ($$v) {
                _vm.customReason = $$v
              },
              expression: "customReason",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }